/**
 * Utilitários Canônicos de Formatação de Data e Hora — Aluno Conectado
 * Governança: Toda data apresentada na interface do usuário DEVE seguir estritamente o formato brasileiro:
 * - Data: DD/MM/AAAA (ex: 12/05/2015)
 * - Data e Hora: DD/MM/AAAA HH:mm (ex: 12/05/2015 14:30)
 */

/**
 * Formata qualquer valor de data (string ISO YYYY-MM-DD, ISO completo, timestamp ou Date)
 * para o padrão brasileiro DD/MM/AAAA.
 * Evita o bug de fuso horário UTC (onde 2015-05-12 torna-se 11/05/2015 em GMT-3)
 * realizando o parse direto das partes YYYY-MM-DD.
 */
export function formatDateBR(dateInput?: string | Date | null): string {
  if (!dateInput) return '—';

  if (dateInput instanceof Date) {
    if (isNaN(dateInput.getTime())) return '—';
    const d = String(dateInput.getDate()).padStart(2, '0');
    const m = String(dateInput.getMonth() + 1).padStart(2, '0');
    const y = dateInput.getFullYear();
    return `${d}/${m}/${y}`;
  }

  const str = String(dateInput).trim();
  if (!str) return '—';

  // Se já estiver no formato brasileiro DD/MM/AAAA
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    return str;
  }

  // Se estiver no formato ISO YYYY-MM-DD ou YYYY-MM-DDT...
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const [year, month, day] = str.slice(0, 10).split('-');
    return `${day}/${month}/${year}`;
  }

  // Fallback seguro via Date
  try {
    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
  } catch {
    /* noop */
  }

  return str;
}

/**
 * Formata data e hora para o padrão brasileiro DD/MM/AAAA HH:mm.
 */
export function formatDateTimeBR(dateInput?: string | Date | null): string {
  if (!dateInput) return '—';

  const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(d.getTime())) return '—';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
